module.exports = __webpack_public_path__ + "img/Bill.a9b50ff3.jpg";